import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { forEach } from "lodash";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { GrnService } from "../../../services/grn.service";
import { Combo2Service } from "../../../services/index";
declare var google;

@Component({
  selector: "grn",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./grn.html",
})
export class GrnListComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  design_no: any;
  grn_no:any;
  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    party_code: "",
    design_no: "",
    pd_code: "",
    po_no: "",
    inv_ref: "",
    inv_no: "",
    grn_from_date: "",
    grn_to_date: "",
    grn_no:"",
    finyear: "2019-2020",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "grn_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("printTemplate") printTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  groupCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  data: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  grnList: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private grn: GrnService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    public toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    this.data = {
      grnList: [],
    };
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(today.getMonth() - 1);
    this.filter.grn_to_date = this.datePipe.transform(today, "yyyy-MM-dd");
    this.filter.grn_from_date = this.datePipe.transform(oneMonthAgo, "yyyy-MM-dd");
    this.getGrnList();
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Party Code",
        prop: "party_code",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Po No",
        prop: "po_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Inv No",
        prop: "inv_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Inv.Ref No",
        prop: "inv_ref_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Inv Date",
        prop: "inv_date_formatted",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "GRN Date",
        prop: "grn_date_formatted",
        headerClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "GRN No",
        prop: "grn_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "LR No",
        prop: "lr_no",
        cellClass: "text-right",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      //  {name: 'RC No',prop: 'rc_no',cellClass: 'text-right', minWidth: 80,maxWidth: 80,width: 80 },
      {
        name: "Barcode",
        prop: "barcode",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        cellTemplate: this.printTemplate,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 140,
        maxWidth: 140,
        headerClass: "text-center",
        width: 140,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);
    this.finyearCombo();

    
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }
  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.filter.finyear = res.data[0].finyear;
      that.pageCallback({ offset: 0 });
    });
  }
  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getGrnList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.party_code = "";
    this.filter.pd_code = "";
    this.filter.po_no = "";
    this.filter.inv_no = "";
    this.filter.inv_ref = "";
    this.filter.design_no = "";
    this.filter.grn_no = "";
    const today = new Date();
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(today.getMonth() - 1);
    this.filter.grn_to_date = this.datePipe.transform(today, "yyyy-MM-dd");
    this.filter.grn_from_date = this.datePipe.transform(oneMonthAgo, "yyyy-MM-dd");
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getGrnList();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  addEditGrn(mode: string, row: any): void {
    this.filterExpand = true;
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.filterExpand = true;
      this.getGrnList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "ADD GRN",
          title: "ADD GRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditGrn",
        },
      };
    } else if (mode == "Edit") {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "EDIT GRN",
          title: "EDIT GRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditGrn",
        },
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          //   tabParent: 'Transaction',
          tabName: "VIEW GRN",
          title: "VIEW GRN",
          tabParent: "CLOTH",
          mode: mode,
          data: row,
          name: "AddEditGrn",
        },
      };
    }

    this.tabUpdateEvent.emit(tabObj);
  }
  getGrnList(): void {
    if (this.filter.grn_from_date == "") {
      this.filter.grn_from_date == "";
    } else {
      this.filter.grn_from_date = this.datePipe.transform(
        this.filter.grn_from_date,
        "yyyy-MM-dd"
      );
    }
    if (this.filter.grn_to_date == "") {
      this.filter.grn_to_date == "";
    } else {
      this.filter.grn_to_date = this.datePipe.transform(
        this.filter.grn_to_date,
        "yyyy-MM-dd"
      );
    }
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      party_code: this.filter.party_code,
      po_no: this.filter.po_no,
      inv_ref: this.filter.inv_ref,
      inv_no: this.filter.inv_no,
      grn_from_date: this.filter.grn_from_date,
      grn_to_date: this.filter.grn_to_date,
      finyear: this.filter.finyear,
      pd_code: this.filter.pd_code,
      design_no: this.filter.design_no,
      grn_no:this.filter.grn_no
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.grn.getGrnList(params).then(function (res: any) {
      that.loadingIndicator = false;
      that.page.count = res.totCnt;
      that.grnList = res.data;
    });
  }

  deleteGrn(row: any): void {
    let that = this;
    row["tabevent"] = undefined;
    swal({
      title: "Delete GRN — Are you sure?",
      html:
        "<table style='margin:auto;text-align:left;font-size:14px;line-height:2'>" +
        "<tr><td><b>GRN No</b></td><td>&nbsp;:&nbsp;</td><td>" + row["grn_no"] + "</td></tr>" +
        "<tr><td><b>GRN Date</b></td><td>&nbsp;:&nbsp;</td><td>" + row["grn_date_formatted"] + "</td></tr>" +
        "<tr><td><b>Party</b></td><td>&nbsp;:&nbsp;</td><td>" + (row["party_name"] || row["party_code"]) + "</td></tr>" +
        "</table>",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
      confirmButtonColor: "#e53935",
    }).then(
      function () {
        that.isLoadMask = that.grn.deleteGrn(row).then(function (res: any) {
          that.loadingIndicator = false;
          that.getGrnList();
          let errtype = "success",
            errmsg = res.message;
          if (!res.success) {
            errtype = "error";
          }
          that.toasterService.pop({
            bodyOutputType: 1,
            type: errtype,
            title: errtype.toUpperCase(),
            body: errmsg,
          });
        });
      },
      function (dismiss) {}
    );
  }

  loadeditgrnlist(row) {
    let params = {
      grn_id: row.grn_id,
      grn_no: row.grn_no,
    };
    this.grn.getEditGrnList(params).then((res: any) => {
      this.clickPrint(row, res.data);
      this.data.grnList = res.data;
      this.data.grn_no = res.data;
      this.design_no = res.design_no - 1;
    });
  }

  clickPrint(row, data) {
    
    let that = this;
    let params: any = Object.assign({}, row);
    data.forEach(el => {
      el.recvd_width = el.inv_rec_width;
    });
    params["data"] = JSON.stringify(data);
    params["style"] = data[0].style;
    that.isLoadMask = that.grn.grnprint(params).then(function (res: any) {});
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/grn/grn.ts